module.exports = __webpack_public_path__ + "media/images/svgs/pattern-6f0bbf281e941ddf6f74a6e3d353537b.svg";